import { SovosBox, SovosButton, SovosTypography } from 'mosaic-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const FormStepLayout: React.FC<{
	title: string;
	subTitle?: string;
	errors?: string[];
	showErrors?: boolean;
	onContinue: () => void;
	continueButton?: React.ReactNode;
	children: React.ReactNode;
}> = ({
	title,
	subTitle,
	errors,
	showErrors,
	onContinue,
	continueButton,
	children,
}) => {
	const navigate = useNavigate();
	return (
		<>
			{showErrors && errors && errors.length > 0 && (
				<SovosBox
					component='ul'
					sx={{
						width: '100%',
						color: 'error.main',
						bgcolor: 'rgba(219, 50, 45, 0.08)',
						px: 2,
						py: 1.5,
						mt: 1,
						mb: 3,
						borderRadius: 1,
						typography: 'body1',
						'& > li': {
							color: 'error.dark',
							listStylePosition: 'inside',
							my: 0.5,
						},
					}}
				>
					{errors.map((error) => (
						<SovosBox key={error} component='li'>
							{error}
						</SovosBox>
					))}
				</SovosBox>
			)}

			<SovosBox sx={{ pb: 2 }}>
				<SovosTypography variant='h5'>{title}</SovosTypography>
				{subTitle && <SovosTypography>{subTitle}</SovosTypography>}
			</SovosBox>
			{children}
			<SovosBox display='flex' py={2}>
				<SovosButton
					onClick={() => navigate('/')}
					variant='text'
					sx={{ mr: 1 }}
					data-testid='cancel-button-step-layout'
				>
					Cancel
				</SovosButton>
				{continueButton || (
					<SovosButton
						data-testid='continue-button-step-layout'
						onClick={onContinue}
					>
						Continue
					</SovosButton>
				)}
			</SovosBox>
		</>
	);
};

export default FormStepLayout;
